module.exports = __webpack_public_path__ + "img/cancel.bb9f7a0a.svg";